import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Equipement, EquipementType} from '../../models/equipement';
import {CarnetEquipement} from '../../models/carnetEquipement';
import {faPlus} from '@fortawesome/free-solid-svg-icons';
import {LogementService} from '../../services/logement.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {EquipementService} from '../../services/equipement.service';
import {Observable} from 'rxjs';
import {Logement} from '../../models/logement';

@Component({
    selector: 'app-equipements',
    templateUrl: './equipements.component.html',
    styleUrls: ['./equipements.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EquipementsComponent implements OnInit {

  faPlus = faPlus;

  logement$: Observable<Logement> = null;

  EquipementType = EquipementType;

  carnetEquipement$: Observable<CarnetEquipement[]> = null;
  filteredEquipements: CarnetEquipement[] = null;

  constructor(private logementService: LogementService, public equipementService: EquipementService, public modalService: NgbModal){
  }

  ngOnInit(): void {
    this.logement$ = this.logementService.logementCourant;
    this.carnetEquipement$ = this.equipementService.carnetEquipement;
    this.logement$.subscribe(logement => {
      this.equipementService.load(logement.id);
    });
    this.carnetEquipement$.subscribe(data => {

      this.filteredEquipements = data.filter(carnetEquipement => carnetEquipement.equipement.type == 'INDIVIDUEL' || carnetEquipement.equipement.societeEquipementPartage);
    });
  }

  delete(carnetEquipement: CarnetEquipement) {
    if( this.equipementService.isAuthorizedToEdit(carnetEquipement)){
      const logementId = this.logementService.getLogementCourantId();

      this.equipementService.removeEquipementIndividuel(logementId, carnetEquipement.equipement.id).then(data => {
        this.equipementService.load(logementId);
      });
    }
  }
}
